import { gql, useQuery } from "@apollo/client";
import { ShipmentStopType } from "@api/graphql/generated/generated-types";

const FORCE_COMPLETE_MODAL_SHIPMENT_QUERY = gql`
  query ForceCompleteModalShipment($courierId: ID!, $shipmentId: ID!) {
    shipmentById(courierId: $courierId, shipmentId: $shipmentId) {
      id
      stops {
        id
        type
        completedAt
        dispatchZone
        streetAddress
        city
        companyName
        tasks {
          sequenceNumber
        }
      }
    }
  }
`;

export interface ForceCompleteModalStop {
  id: string;
  type: ShipmentStopType;
  completedAt?: number | null;
  dispatchZone?: string | null;
  streetAddress?: string | null;
  city?: string | null;
  companyName?: string | null;
  tasks?: Array<{
    sequenceNumber: number;
  }> | null;
}

export interface ForceCompleteModalShipment {
  id: string;
  stops: ForceCompleteModalStop[];
}

interface ForceCompleteModalShipmentQueryData {
  shipmentById: ForceCompleteModalShipment | null;
}

interface ForceCompleteModalShipmentQueryVariables {
  courierId: string;
  shipmentId: string;
}

interface UseForceCompleteModalShipmentOptions {
  courierId: string | undefined;
  shipmentId: string;
  skip?: boolean;
}

export function useForceCompleteModalShipment({
  courierId,
  shipmentId,
  skip = false,
}: UseForceCompleteModalShipmentOptions) {
  const { data, loading, error, refetch } = useQuery<
    ForceCompleteModalShipmentQueryData,
    ForceCompleteModalShipmentQueryVariables
  >(FORCE_COMPLETE_MODAL_SHIPMENT_QUERY, {
    variables: { courierId: courierId!, shipmentId },
    skip: skip || !courierId || !shipmentId,
    fetchPolicy: "network-only",
  });

  return {
    shipment: data?.shipmentById ?? undefined,
    loading,
    error,
    refetch,
  };
}
